<template>
    <div>
        <ubi-panel>
            <ubi-form-group :title="$t('posts.interiorTitle')">
                <el-row>
                    <el-col :span="24">
                        <el-form-item :label="$labels.nb_pieces_logement"
                                      prop="nb_pieces_logement"
                        >
                            <el-input v-mask="'#################'" v-model.number="post.nb_pieces_logement"
                                      type="nb_pieces_logement">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.surface_habitable"
                                      prop="surface_habitable"
                        >
                            <el-input v-model="post.surface_habitable"
                                      type="number" step="0.01">
                                <div slot="append">m²</div>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.surface_carrez"
                                      prop="surface_carrez"
                        >
                            <el-input v-mask="'#################'" v-model.number="post.surface_carrez"
                                      type="surface_carrez">
                                <div slot="append">m²</div>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.nombre_de_chambres"
                                      prop="nombre_de_chambres"
                        >
                            <el-input v-mask="'#################'" v-model.number="post.nombre_de_chambres"
                                      type="nombre_de_chambres">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.nb_salles_d_eau"
                                      prop="nb_salles_d_eau"
                        >
                            <el-input v-mask="'#################'" v-model.number="post.nb_salles_d_eau"
                                      type="nb_salles_d_eau">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.nb_salles_de_bain"
                                      prop="nb_salles_de_bain"
                        >
                            <el-input v-mask="'#################'" v-model.number="post.nb_salles_de_bain"
                                      type="nb_salles_de_bain">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.nb_wc"
                                      prop="nb_wc"
                        >
                            <el-input v-mask="'#################'" v-model.number="post.nb_wc" type="nb_wc">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        {{ $t("posts.edit.interiorServices") }} :<br>
                        <br>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.wc_independant">
                            <el-radio v-model="post.wc_independant" label="oui">{{ $t("general.yes") }}</el-radio>
                            <el-radio v-model="post.wc_independant" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.sejour">
                            <el-radio v-model="post.sejour" label="oui">{{ $t("general.yes") }}</el-radio>
                            <el-radio v-model="post.sejour" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="post.sejour == 'oui'">
                        <el-form-item :label="$labels.surface_sejour"
                                      prop="surface_sejour"
                        >
                            <el-input v-mask="'#################'" v-model.number="post.surface_sejour"
                                      type="surface_sejour">
                                <template slot="append">m²</template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.salle_a_manger">
                            <el-radio v-model="post.salle_a_manger" label="oui">{{ $t("general.yes") }}</el-radio>
                            <el-radio v-model="post.salle_a_manger" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="post.salle_a_manger == 'oui'">
                        <el-form-item :label="$labels.surface_salle_a_manger"
                                      prop="surface_salle_a_manger"
                        >
                            <el-input v-mask="'#################'" v-model.number="post.surface_salle_a_manger"
                                      type="surface_salle_a_manger">
                                <template slot="append">m²</template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item>
                            <div style="font-size: 12px;">{{$labels.type_cuisine}}
                                <el-button class="el-icon-error reset-radio"
                                           v-if="post.type_cuisine != '' && post.type_cuisine != undefined && post.type_cuisine != null"
                                           @click="post.type_cuisine = null"
                                           circle></el-button>
                            </div>
                            <el-radio-group v-model="post.type_cuisine">
                                <el-radio
                                        v-for="cuisineChoice in this.$parent.getChoices('type_cuisine')"
                                        :label="cuisineChoice"
                                        :value="cuisineChoice">
                                </el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.degagement">
                            <el-radio v-model="post.degagement" label="oui">{{ $t("general.yes") }}</el-radio>
                            <el-radio v-model="post.degagement" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.coin_bureau">
                            <el-radio v-model="post.coin_bureau" label="oui">{{ $t("general.yes") }}</el-radio>
                            <el-radio v-model="post.coin_bureau" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.dressing">
                            <el-radio v-model="post.dressing" label="oui">{{ $t("general.yes") }}</el-radio>
                            <el-radio v-model="post.dressing" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.buanderie">
                            <el-radio v-model="post.buanderie" label="oui">{{ $t("general.yes") }}</el-radio>
                            <el-radio v-model="post.buanderie" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item>
                            <div style="font-size: 12px;">{{ $labels.eau_chaude_distribution }}
                                <el-button class="el-icon-error reset-radio"
                                           v-if="post.eau_chaude_distribution != '' && post.eau_chaude_distribution != undefined && post.eau_chaude_distribution != null"
                                           @click="post.eau_chaude_distribution = null"
                                           circle></el-button>
                            </div>
                            <el-radio-group v-model="post.eau_chaude_distribution">
                                <el-radio
                                        v-for="eauChaudeDistributionChoice in this.$parent.getChoices('eau_chaude_distribution')"
                                        :label="eauChaudeDistributionChoice"
                                        :value="eauChaudeDistributionChoice">
                                </el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.possede_cajibi">
                            <el-radio v-model="post.possede_cajibi" label="oui">{{ $t("general.yes") }}</el-radio>
                            <el-radio v-model="post.possede_cajibi" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.chauffage_energie">
                            <el-select
                                    v-model="post.chauffage_energie"
                                    :placeholder="$t('posts.edit.selectTypePlaceholder')"
                                    clearable
                                    filterable
                            >
                                <el-option
                                        style="text-transform:capitalize"
                                        v-for="energieChauffageChoice in this.$parent.getChoices('chauffage_energie')"
                                        :key="energieChauffageChoice"
                                        :label="energieChauffageChoice"
                                        :value="energieChauffageChoice"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item>
                            <div style="font-size: 12px;">{{$labels.chauffage_type}}
                                <el-button class="el-icon-error reset-radio"
                                           v-if="post.chauffage_type != '' && post.chauffage_type != undefined && post.chauffage_type != null"
                                           @click="post.chauffage_type = null"
                                           circle></el-button>
                            </div>
                            <el-radio-group v-model="post.chauffage_type">
                                <el-radio
                                        v-for="energieChauffageChoice in this.$parent.getChoices('chauffage_type')"
                                        :label="energieChauffageChoice"
                                        :value="energieChauffageChoice">
                                </el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.poele_a_bois">
                            <el-radio v-model="post.poele_a_bois" label="oui">{{ $t("general.yes") }}</el-radio>
                            <el-radio v-model="post.poele_a_bois" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item>
                            <div style="font-size: 12px;">{{$labels.vitrages}}
                                <el-button class="el-icon-error reset-radio"
                                           v-if="post.vitrages != '' && post.vitrages != undefined && post.vitrages != null"
                                           @click="post.vitrages = null"
                                           circle></el-button>
                            </div>
                            <el-radio-group v-model="post.vitrages">
                                <el-radio
                                        v-for="natureVitrageChoice in this.$parent.getChoices('vitrages')"
                                        :label="natureVitrageChoice"
                                        :value="natureVitrageChoice">
                                </el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.volets_roulants_electriques">
                            <el-radio v-model="post.volets_roulants_electriques" label="oui">{{ $t("general.yes") }}
                            </el-radio>
                            <el-radio v-model="post.volets_roulants_electriques" label="non">{{ $t("general.no") }}
                            </el-radio>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.duplex">
                            <el-radio v-model="post.duplex" label="oui">{{ $t("general.yes") }}</el-radio>
                            <el-radio v-model="post.duplex" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.etage"
                                      prop="etage"
                        >
                            <el-input v-mask="'#################'" v-model.number="post.etage" type="etage">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.nombre_etages"
                                      prop="nombre_etages"
                        >
                            <el-input v-mask="'#################'" v-model.number="post.nombre_etages"
                                      type="nombre_etages">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.ascenseur">
                            <el-radio v-model="post.ascenseur" label="oui">{{ $t("general.yes") }}</el-radio>
                            <el-radio v-model="post.ascenseur" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                    </el-col>

                </el-row>
            </ubi-form-group>
        </ubi-panel>

        <ubi-panel>
            <ubi-form-group :title="$t('posts.exteriorTitle')">
                <el-row>
                    <el-col :span="24">
                        <el-form-item :label="$labels.terrasse">
                            <el-radio v-model="post.terrasse" label="oui">{{ $t("general.yes") }}</el-radio>
                            <el-radio v-model="post.terrasse" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="post.terrasse == 'oui'">
                        <el-form-item :label="$labels.terrasse_surface"
                                      prop="terrasse_surface"
                        >
                            <el-input v-mask="'#################'" v-model.number="post.terrasse_surface"
                                      type="terrasse_surface">
                                <template slot="append">m²</template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="post.balcon == 'oui'">
                        <el-form-item :label="$labels.nb_balcons"
                                      prop="nb_balcons"
                        >
                            <el-input v-mask="'#################'" v-model.number="post.nb_balcons" type="nb_balcons">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="post.balcon == 'oui'">
                        <el-form-item :label="$labels.surface_balcon"
                                      prop="surface_balcon"
                        >
                            <el-input v-mask="'#################'" v-model.number="post.surface_balcon"
                                      type="surface_balcon">
                                <template slot="append">m²</template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.loggia">
                            <el-radio v-model="post.loggia" label="oui">{{ $t("general.yes") }}</el-radio>
                            <el-radio v-model="post.loggia" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.garage">
                            <el-radio v-model="post.garage" label="oui">{{ $t("general.yes") }}</el-radio>
                            <el-radio v-model="post.garage" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="post.garage == 'oui'">
                        <el-form-item :label="$labels.nb_garages"
                                      prop="nb_garages"
                        >
                            <el-input v-mask="'#################'" v-model.number="post.nb_garages" type="nb_garage">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.possede_parking">
                            <el-radio v-model="post.possede_parking" label="oui">{{ $t("general.yes") }}</el-radio>
                            <el-radio v-model="post.possede_parking" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="post.possede_parking == 'oui'">
                        <el-form-item :label="$labels.nb_parkings"
                                      prop="nb_parkings"
                        >
                            <el-input v-mask="'#################'" v-model.number="post.nb_parkings" type="nb_parking">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item>
                            <div style="font-size: 12px;">{{ $labels.type_stationnement }}
                                <el-button class="el-icon-error reset-radio"
                                           v-if="post.type_stationnement != '' && post.type_stationnement != undefined && post.type_stationnement != null"
                                           @click="post.type_stationnement = null"
                                           circle></el-button>
                            </div>
                            <el-radio-group v-model="post.type_stationnement">
                                <el-radio
                                        v-for="typeStationnementChoice in this.$parent.getChoices('type_stationnement')"
                                        :label="typeStationnementChoice"
                                        :value="typeStationnementChoice">
                                </el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.possede_box">
                            <el-radio v-model="post.possede_box" label="oui">{{ $t("general.yes") }}</el-radio>
                            <el-radio v-model="post.possede_box" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.cave">
                            <el-radio v-model="post.cave" label="oui">{{ $t("general.yes") }}</el-radio>
                            <el-radio v-model="post.cave" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="post.cave == 'oui'">
                        <el-form-item :label="$labels.surface_cave"
                                      prop="surface_cave"
                        >
                            <el-input v-mask="'#################'" v-model.number="post.surface_cave"
                                      type="surface_cave">
                                <template slot="append">m²</template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item :label="$labels.type_jardin" prop="type_jardin">
                        <el-button class="el-icon-error reset-radio" v-if="post.type_jardin != '' && post.type_jardin != undefined && post.type_jardin != null" @click="post.type_jardin = null" circle></el-button>
                        <el-radio-group v-model="post.type_jardin">
                          <el-radio :label="jardinChoice" :value="jardinChoice" v-for="jardinChoice in this.$parent.getChoices('type_jardin')"></el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="post.type_jardin == 'privatif'">
                      <el-form-item :label="$labels.surface_jardin" prop="surface_jardin">
                        <el-input v-mask="'#################'" v-model.number="post.surface_jardin" type="surface_jardin">
                          <div slot="append">m²</div>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.grenier">
                            <el-select
                                    v-model="post.grenier"
                                    :placeholder="$t('posts.edit.selectTypePlaceholder')"
                                    clearable
                                    filterable
                            >
                                <el-option
                                        style="text-transform:capitalize"
                                        v-for="grenierChoice in this.$parent.getChoices('grenier')"
                                        :key="grenierChoice"
                                        :label="grenierChoice"
                                        :value="grenierChoice"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.avec_toit_terrasse">
                            <el-radio v-model="post.avec_toit_terrasse" label="oui">{{ $t("general.yes") }}</el-radio>
                            <el-radio v-model="post.avec_toit_terrasse" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.cable_tv">
                            <el-radio v-model="post.cable_tv" label="oui">{{ $t("general.yes") }}</el-radio>
                            <el-radio v-model="post.cable_tv" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.climatise">
                            <el-radio v-model="post.climatise" label="oui">{{ $t("general.yes") }}</el-radio>
                            <el-radio v-model="post.climatise" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.cheminee">
                            <el-radio v-model="post.cheminee" label="oui">{{ $t("general.yes") }}</el-radio>
                            <el-radio v-model="post.cheminee" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.placards_integres">
                            <el-radio v-model="post.placards_integres" label="oui">{{ $t("general.yes") }}</el-radio>
                            <el-radio v-model="post.placards_integres" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.revetement_sol_principal">
                            <el-select
                                    v-model="post.revetement_sol_principal"
                                    :placeholder="$t('posts.edit.selectTypePlaceholder')"
                                    clearable
                                    filterable
                            >
                                <el-option
                                        style="text-transform:capitalize"
                                        v-for="revetementSolChoice in this.$parent.getChoices('revetement_sol_principal')"
                                        :key="revetementSolChoice"
                                        :label="revetementSolChoice"
                                        :value="revetementSolChoice"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.digicode">
                            <el-radio v-model="post.digicode" label="oui">{{ $t("general.yes") }}</el-radio>
                            <el-radio v-model="post.digicode" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.interphone">
                            <el-radio v-model="post.interphone" label="oui">{{ $t("general.yes") }}</el-radio>
                            <el-radio v-model="post.interphone" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.videophone">
                            <el-radio v-model="post.videophone" label="oui">{{ $t("general.yes") }}</el-radio>
                            <el-radio v-model="post.videophone" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.alarme_habitation">
                            <el-radio v-model="post.alarme_habitation" label="oui">{{ $t("general.yes") }}</el-radio>
                            <el-radio v-model="post.alarme_habitation" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.gardien">
                            <el-radio v-model="post.gardien" label="oui">{{ $t("general.yes") }}</el-radio>
                            <el-radio v-model="post.gardien" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.piscine">
                            <el-radio v-model="post.piscine" label="oui">{{ $t("general.yes") }}</el-radio>
                            <el-radio v-model="post.piscine" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-checkbox v-model="post.pieds_dans_eau" true-label="oui" false-label="non">
                        {{ $labels.pieds_dans_eau }}
                      </el-checkbox>
                    </el-col>
                    <el-row>
                      <el-col :span="24">
                        <el-form-item>
                          <div style="font-size: 12px;">{{$labels.piscine_type}}
                            <el-button class="el-icon-error reset-radio"
                                       v-if="post.piscine_type != '' && post.piscine_type != undefined && post.piscine_type != null"
                                       @click="post.piscine_type = null"
                                       circle></el-button>
                          </div>
                          <el-radio-group v-model="post.piscine_type">
                            <el-radio
                                v-for="piscineChoice in this.$parent.getChoices('piscine_type')"
                                :label="piscineChoice"
                                :value="piscineChoice">
                            </el-radio>
                          </el-radio-group>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :lg="24">
                        <el-form-item :label="$t('posts.edit.obligationToClearBrush')">
                          <el-radio v-model="post.obligation_debroussaillement" label="oui">{{ $t("general.yes") }}</el-radio>
                          <el-radio v-model="post.obligation_debroussaillement" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-col :span="24">
                        <el-form-item :label="$labels.acces_handicapes">
                            <el-radio v-model="post.acces_handicapes" label="oui">{{ $t("general.yes") }}</el-radio>
                            <el-radio v-model="post.acces_handicapes" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.acces_internet_haut_debit">
                            <el-radio v-model="post.acces_internet_haut_debit" label="oui">{{ $t("general.yes") }}
                            </el-radio>
                            <el-radio v-model="post.acces_internet_haut_debit" label="non">{{ $t("general.no") }}
                            </el-radio>
                        </el-form-item>
                    </el-col>
                </el-row>
            </ubi-form-group>
        </ubi-panel>

        <ubi-panel>
            <ubi-form-group :title="$t('posts.environmentTitle')">
                <el-row>
                    <el-col :span="24">
                        <el-form-item :label="$labels.exposition">
                            <el-select
                                    v-model="post.exposition"
                                    :placeholder="$t('posts.edit.selectTypePlaceholder')"
                                    clearable
                                    filterable
                            >
                                <el-option
                                        style="text-transform:capitalize"
                                        v-for="expositionChoice in this.$parent.getChoices('exposition')"
                                        :key="expositionChoice"
                                        :label="expositionChoice"
                                        :value="expositionChoice"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col :span="24">
                        <el-form-item :label="$t('posts.environmentTitle')">
                            <el-select
                                    v-model="post.environnement"
                                    :placeholder="$t('posts.edit.selectTypePlaceholder')"
                                    clearable
                                    filterable
                            >
                                <el-option
                                        style="text-transform:capitalize"
                                        v-for="environnementChoice in this.$parent.getChoices('environnement')"
                                        :key="environnementChoice"
                                        :label="environnementChoice"
                                        :value="environnementChoice"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.belle_vue">
                            <el-radio v-model="post.belle_vue" label="oui">{{ $t("general.yes") }}</el-radio>
                            <el-radio v-model="post.belle_vue" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.standing">
                            <el-select
                                    v-model="post.standing"
                                    :placeholder="$t('posts.edit.selectTypePlaceholder')"
                                    clearable
                                    filterable
                            >
                                <el-option
                                        style="text-transform:capitalize"
                                        v-for="StandingChoice in this.$parent.getChoices('standing')"
                                        :key="StandingChoice"
                                        :label="StandingChoice"
                                        :value="StandingChoice"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.vue_sur_mer">
                            <el-radio v-model="post.vue_sur_mer" label="oui">{{ $t("general.yes") }}</el-radio>
                            <el-radio v-model="post.vue_sur_mer" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.est_calme">
                            <el-radio v-model="post.est_calme" label="oui">{{ $t("general.yes") }}</el-radio>
                            <el-radio v-model="post.est_calme" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.avec_vis_a_vis">
                            <el-radio v-model="post.avec_vis_a_vis" label="oui">{{ $t("general.yes") }}</el-radio>
                            <el-radio v-model="post.avec_vis_a_vis" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.proche_bus">
                            <el-radio v-model="post.proche_bus" label="oui">{{ $t("general.yes") }}</el-radio>
                            <el-radio v-model="post.proche_bus" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.proche_tram">
                            <el-radio v-model="post.proche_tram" label="oui">{{ $t("general.yes") }}</el-radio>
                            <el-radio v-model="post.proche_tram" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.proche_metro">
                            <el-radio v-model="post.proche_metro" label="oui">{{ $t("general.yes") }}</el-radio>
                            <el-radio v-model="post.proche_metro" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.proche_gare">
                            <el-radio v-model="post.proche_gare" label="oui">{{ $t("general.yes") }}</el-radio>
                            <el-radio v-model="post.proche_gare" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.proche_commerces">
                            <el-radio v-model="post.proche_commerces" label="oui">{{ $t("general.yes") }}</el-radio>
                            <el-radio v-model="post.proche_commerces" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.ecoles_a_proximitees">
                            <el-radio v-model="post.ecoles_a_proximitees" label="oui">{{ $t("general.yes") }}</el-radio>
                            <el-radio v-model="post.ecoles_a_proximitees" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.proche_creche">
                            <el-radio v-model="post.proche_creche" label="oui">{{ $t("general.yes") }}</el-radio>
                            <el-radio v-model="post.proche_creche" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.espaces_verts">
                            <el-radio v-model="post.espaces_verts" label="oui">{{ $t("general.yes") }}</el-radio>
                            <el-radio v-model="post.espaces_verts" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                    </el-col>
                </el-row>
            </ubi-form-group>
        </ubi-panel>

        <ubi-panel>
            <ubi-form-group :title="$t('posts.propertyConditionTitle')">
                <el-row :gutter="20">
                    <el-col :span="6">
                        <el-form-item>
                            <el-checkbox v-model="post.recent" true-label="oui" false-label="non">Recent</el-checkbox>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col>
                        <el-form-item>
                            <div style="font-size: 12px;">{{ $labels.meuble }}
                                <el-button class="el-icon-error reset-radio"
                                           v-if="post.meuble != '' && post.meuble != undefined && post.meuble != null"
                                           @click="post.meuble = null"
                                           circle></el-button>
                            </div>
                            <el-radio-group v-model="post.meuble">
                                <el-radio label="oui">{{ $t("general.yes") }}</el-radio>
                                <el-radio label="non">{{ $t("general.no") }}</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="10">
                        <el-form-item
                                :label="$labels.annee_construction"
                                prop="annee_construction"

                        >
                            <el-input v-mask="'#################'" v-model.number="post.annee_construction"
                                      prop="annee_construction"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item
                                :label="$labels.annee_renovation"
                                prop="annee_renovation"

                        >
                            <el-input v-mask="'#################'" v-model.number="post.annee_renovation"
                                      prop="annee_renovation"></el-input>
                        </el-form-item>
                    </el-col>

                </el-row>
            </ubi-form-group>
        </ubi-panel>
        <dpe-ges :post="post"></dpe-ges>
        <isolation-thermique-solaire :post="post"></isolation-thermique-solaire>
        <securite-bien :post="post"></securite-bien>
    </div>
</template>

<script>
import { getDefinitionDonneeListeeByCode } from '@/services/posts'
import DpeGes from '../Block/DpeGes'
import IsolationThermiqueSolaire from '../Block/IsolationThermiqueSolaire'
import SecuriteBien from "@/pages/posts/forms/Block/SecuriteBien.vue";

export default {
  name: 'PostEditImmoObject4200',
  props: ['post', 'ddList'],
  components: {SecuriteBien, DpeGes, IsolationThermiqueSolaire },
  data () {
    return {}
  },
  computed: {},
  methods: {},
  async beforeMount () {
    let codes = ['type_cuisine', 'eau_chaude_distribution', 'chauffage_energie', 'chauffage_type', 'vitrages', 'type_stationnement', 'type_jardin', 'grenier', 'revetement_sol_principal', 'exposition', 'environnement', 'standing', 'dpe_etiquette_conso', 'dpe_etiquette_ges', 'mandat_statut', 'modalites_recuperation_charges_locatives',
      'obligation_debroussaillement']

    codes = codes.map(function (x) {
      return x.toUpperCase()
    })
    const definitionDonneeListeeByCode = await getDefinitionDonneeListeeByCode({ codes: codes })
    if (definitionDonneeListeeByCode.type == 'error') {
      this.$message({ message: this.$t('error.found'), type: 'error' })
      this.loading = false
      return false
    }
    this.$emit('ddList-update', definitionDonneeListeeByCode)
  }
}
</script>
